export default __webpack_public_path__ + "static/cloud-1-426d7e5830316e79643e7ffe8910cf25.png";